// Events
export const KMFC_REFERENCE_DATA =
  "kaMetlhaFuneralClaim/referenceData/";
export const KMFC_BANK_REFERENCE_DATA_GET_VALUE =
KMFC_REFERENCE_DATA+ "bankReferenceData/getValue/";
export const KMFC_BRANCH_CODES_REFERENCE_DATA_GET_VALUE =
KMFC_REFERENCE_DATA+"branchCodeReferenceData/getValue/";
export const KMFC_BANK_REFERENCE_DATA_SET_VALUE =
KMFC_REFERENCE_DATA+ "bankReferenceData/setValue/";
export const KMFC_BRANCH_CODES_REFERENCE_DATA_SET_VALUE =
KMFC_REFERENCE_DATA+"branchCodeReferenceData/setValue/";

export const getBankReferenceData = () => ({  
  type: KMFC_BANK_REFERENCE_DATA_GET_VALUE,
});
export const getBranchCodeReferenceData = (value) => ({
  type: KMFC_BRANCH_CODES_REFERENCE_DATA_GET_VALUE,
  value
});
export const setBankReferenceData = (value) => ({  
  type: KMFC_BANK_REFERENCE_DATA_SET_VALUE,
  value
});
export const setBranchCodeReferenceData = (value) => ({
  type: KMFC_BRANCH_CODES_REFERENCE_DATA_SET_VALUE,
  value
});

// Branch Code Data API status
export const KMFC_BRANCH_CODES_REFERENCE_DATA_API_STATUS = KMFC_REFERENCE_DATA + 'branchCodeReferenceData/setApiStatus';

export const setBranchCodesApiStatus = (value) => ({
    type: KMFC_BRANCH_CODES_REFERENCE_DATA_API_STATUS,
    value
});

export const KMFC_MAIL_SERVICE= "kaMetlhaFuneralClaim/callMailService/sendMail";
export const sendEmail = (value) => ({type:KMFC_MAIL_SERVICE,value})

export const KMFC_DOCUMENT_MAIL_SERVICE= "kaMetlhaFuneralClaim/uploadDocument/sendDocumentMail";
export const sendUploadDocument = () => ({type:KMFC_DOCUMENT_MAIL_SERVICE})

export const KMFC_SET_REF_NUMBER= "kaMetlhaFuneralClaim/setRefNumber/setRef";
export const setRefNumber = (value) => ({type:KMFC_SET_REF_NUMBER,value})

export const RESET_REFERENCE_DATA =
  "kaMetlhaFuneralClaim/referenceData/setValue/resetState";
export const resetReferenceData = () => ({ type: RESET_REFERENCE_DATA });


